import {
    IntentKind,
    makeIntentBuilderFunction,
    makeIntentGuard,
    type RouteableIntent,
} from '@jet-app/music-classical/intents';

export interface LibraryRecentlyAddedPageIntent extends RouteableIntent {
    $kind: IntentKind.LIBRARY_RECENTLY_ADDED_PAGE;
}

export const isLibraryRecentlyAddedPageIntent =
    makeIntentGuard<LibraryRecentlyAddedPageIntent>(
        IntentKind.LIBRARY_RECENTLY_ADDED_PAGE,
    );

export const makeLibraryRecentlyAddedPageIntent =
    makeIntentBuilderFunction<LibraryRecentlyAddedPageIntent>(
        IntentKind.LIBRARY_RECENTLY_ADDED_PAGE,
    );
